<template>
    <div class="cert-panel">
        <custom-panel :title="title" :height="height" :hideMore="true" @moreClick="moreClickHandle">
            <template #content>
                <a-spin :spinning="loading">
                    <div class="cert-list" v-if="certList.length > 0">
                        <template v-if="certList.length > 0">
                            <div class="cert-item" v-for="item in certList" :key="item.text">
                                <div class="cert-box query">
                                    <picture-preview :images="[item.img]">
                                        <img :src="item.img" :alt="item.text" draggable="false" />
                                    </picture-preview>
                                </div>
                                <div class="cert-name">{{ item.text }}</div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="cert-item" v-for="item in defaultCertList" :key="item.text">
                                <div class="cert-box default">
                                    <picture-preview :images="[item.img]">
                                        <img :src="item.img" :alt="item.text" draggable="false" />
                                    </picture-preview>
                                </div>
                                <div class="cert-name">{{ item.text }}</div>
                            </div>
                        </template>
                    </div>
                    <a-empty v-else />
                </a-spin>
            </template>
        </custom-panel>
    </div>
</template>

<script>
import { queryHomeParams } from '../../../common/api';
import CustomPanel from '@/components/custom-panel.vue';
import PicturePreview from '@/components/picture-preview.vue';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel,
        PicturePreview
    },

    data() {
        return {
            title: '资质证书',
            defaultCertList: [
                { img: require('../../../assets/home/CMA资质认定证书.png'), text: 'CMA资质认定证书' },
                { img: require('../../../assets/home/CNAS实验室认可证书.png'), text: 'CNAS实验室认可证书' },
                {
                    img: require('../../../assets/home/PTP能力验证提供者认可证书.png'),
                    text: 'PTP能力验证提供者认可证书'
                },
                { img: require('../../../assets/home/实验室动物使用许可证.png'), text: '实验室动物使用许可证' }
            ],
            certList: [],
            loading: false
        };
    },

    methods: {
        moreClickHandle() {
            // console.log('more click');
        },

        async getCertList() {
            this.loading = true;
            const res = await queryHomeParams();
            this.certList = res.data.qcPicList.map(item => {
                return {
                    img: item.picFile,
                    text: item.picTitle
                };
            });
            this.loading = false;
        }
    },

    created() {
        this.getCertList();
    }
};
</script>

<style lang="scss" scoped>
.cert-panel {
    .cert-list {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        gap: 16px;

        .cert-item {
            width: 270px;
            height: 364px;
            padding: 16px;
            border-radius: 4px;
            background: #fafcff;
            border: 1px solid #dfe8f8;

            .cert-box {
                &.default {
                    .picture-preview ::v-deep .preview-trigger > img {
                        width: 236px;
                        height: 308px;
                    }
                }

                &.query {
                    width: 236px;
                    height: 308px;
                    background: url(../imgs/bg-auth.png) no-repeat center center;
                    display: flex;
                    justify-content: center;

                    .picture-preview ::v-deep .preview-trigger > img {
                        width: 202px;
                        height: 276px;
                        margin-top: 8px;

                        // width: 236px;
                        // height: 308px;
                    }
                }
            }

            .cert-name {
                font-size: 18px;
                color: #333333;
                text-align: center;
                line-height: 32px;
                font-weight: 600;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

</style>
